import './App.css';
import React, { useEffect, useState } from "react";
import { Toaster } from 'react-hot-toast'
import { useAuthContext } from './hooks/adminAuthHook';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import MoonLoader from "react-spinners/MoonLoader";
import Login from './components/Login'
import Packages from './components/Packages'
import Dashboard from './components/Dashboard'
import Bookings from './components/Bookings'
import Agencies from './components/Agencies'
import AgencyProfileDetails from './components/AgencyProfileDetails'
import Configurations from './components/Configurations'
import Sidebar from './components/Sidebar'
import Navbar from './components/Navbar'
function App() {
  const { admin } = useAuthContext();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (admin !== undefined) {
      setLoading(false);
    }
  }, [admin]);

  if (loading) {
    return <div className='mt-5 '>
      <MoonLoader color="#e3d900" className='mt-5 mx-auto' />
    </div>
  }
  return (
    <div className="App">
      <BrowserRouter>
        {admin && <Navbar />}
        {admin && <Sidebar />}
        <Routes>
          <Route path="/" element={admin ? <Dashboard /> : <Login></Login>} />
          <Route path="/agencies" element={admin ? <Agencies></Agencies> : <Navigate to="/" />} />
          <Route path="/packages" element={admin ? <Packages></Packages> : <Navigate to="/" />} />
          <Route path="/bookings" element={admin ? <Bookings></Bookings> : <Navigate to="/" />} />
          <Route path="/agency/profile/:id" element={admin ? <AgencyProfileDetails></AgencyProfileDetails> : <Navigate to="/" />} />
          <Route path="/setting/:type" element={admin ? <Configurations></Configurations> : <Navigate to="/" />} />

        </Routes>
      </BrowserRouter>

      <Toaster
        position="top-center"
        reverseOrder={false}
      />
    </div>
  );
}

export default App;
